__turbopack_context__.v({
  "bannerWrapper": "tWVCoG_bannerWrapper",
});
